// extracted by mini-css-extract-plugin
export default {"downloadApp":"Download_downloadApp__z5+aL","appStoreEng":"Download_appStoreEng__-rjGV","googlePlayEng":"Download_googlePlayEng__yTeUM","download":"Download_download__EFLNB"};